module.exports = __webpack_public_path__ + "assets/brightedge.07c1b271.svg";